"use strict";
var __values = (this && this.__values) || function(o) {
    var s = typeof Symbol === "function" && Symbol.iterator, m = s && o[s], i = 0;
    if (m) return m.call(o);
    if (o && typeof o.length === "number") return {
        next: function () {
            if (o && i >= o.length) o = void 0;
            return { value: o && o[i++], done: !o };
        }
    };
    throw new TypeError(s ? "Object is not iterable." : "Symbol.iterator is not defined.");
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.guessBlockName = void 0;
var titleElements = ["h1", "h2"];
var guessBlockName = function (block) {
    var e_1, _a;
    var blockElement = block.$ctrl.ui.blockElement;
    try {
        for (var titleElements_1 = __values(titleElements), titleElements_1_1 = titleElements_1.next(); !titleElements_1_1.done; titleElements_1_1 = titleElements_1.next()) {
            var titleElem = titleElements_1_1.value;
            var title = blockElement.find("content-area ".concat(titleElem)).text() || blockElement.find(".editor-v1 ".concat(titleElem)).text();
            if (title.length) {
                block.name = title;
                break;
            }
        }
    }
    catch (e_1_1) { e_1 = { error: e_1_1 }; }
    finally {
        try {
            if (titleElements_1_1 && !titleElements_1_1.done && (_a = titleElements_1.return)) _a.call(titleElements_1);
        }
        finally { if (e_1) throw e_1.error; }
    }
};
exports.guessBlockName = guessBlockName;
